<template>
  <v-container class="pa-0" max-width="100%">
    <!-- Current Debt Info -->
    <v-row class="graybar text-center pt-3 pb-3 px-4 align-center">
      <!-- Current Debt Info -->
      <v-col
        cols="12"
        sm="3"
        md="3"
        lg="3"
        align-self="center"
        :class="$vuetify.display.xs ? 'currentdebtinfoMob pb-4' : 'currentdebtinfo pl-1'"
      >
        {{ $t('L_current_debt_info') }}
      </v-col>
      <!-- Your total current debt -->
      <v-col cols="12" sm="3" md="3" lg="3" align-self="center" class="text-center">
        <div :class="$vuetify.display.xs ? 'titleforpillMob pb-1' : 'titleforpill mb-2'">
          {{ $t('L_your_total_current_debt') }}
        </div>
        <div :class="$vuetify.display.xs ? 'whitepillMob pb-3' : 'whitepill ml-1 mr-1 '">
          {{ totalCurrentDebt }}
        </div>
      </v-col>
      <!-- Your total monthly payment -->
      <v-col cols="12" sm="3" md="3" lg="3" align-self="center" class="text-center">
        <div :class="$vuetify.display.xs ? 'titleforpillMob pb-1' : 'titleforpill mb-2'">
          {{ $t('L_your_total_monthly_payment') }}
        </div>
        <div :class="$vuetify.display.xs ? 'whitepillMob pb-3' : 'whitepill ml-1 mr-1 '">
          {{ totalDebtPayment }}
        </div>
      </v-col>
      <!-- Update Your Debt Info -->
      <v-col cols="12" sm="3" md="3" lg="3" align-self="center">
        <div
          :class="
            $vuetify.display.xs
              ? 'updateyourdebtbuttonMob updateYourDebtLabelMobile'
              : 'updateyourdebtbutton'
          "
          class="d-flex row pa-2"
          @click="updateYourDebt"
        >
          <v-img
            width="24px"
            height="24px"
            alt="Update Your Debt info image"
            class="d-flex inlign align-self-center"
            src="../assets/update-24px.svg"
          />&nbsp;
          <span class="text-decoration-underline text-body-2 pr-2 d-flex inlign align-self-center"
            >{{ $t('L_update_your_debt_info') }}
          </span>
        </div>
      </v-col>
    </v-row>
    <!-- With vs Without -->
    <v-row class="blackborder text-center">
      <!-- With Debt Stacking -->
      <v-col
        :cols="$vuetify.display.xs ? '12' : '6'"
        class="border-opacity-100"
        :class="$vuetify.display.xs ? 'border-b-lg' : 'border-e-lg'"
      >
        <v-row>
          <v-col cols="12" class="debtstacking textcolorblue">
            {{ $t('L_with_debt_stacking') }}
            <v-tooltip
              max-width="300"
              html="true"
              open-on-click
              location="bottom"
              close-delay="2000"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  color="primary"
                  size="16"
                  v-bind="props"
                  class="moveiconup"
                  :icon="mdiHelpCircle"
                />
              </template>
              <span class="moveTextBelowIcon">
                <p v-html="$t('L_with_debt_stacking_this_illustration_assumes_that')" />
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" class="debtfreedomage textcolorblue">
            {{ $t('L_debt_freedom_age') }}
          </v-col>
          <v-col cols="12" class="age textcolorblue py-0">
            {{ primaryDatePayOffAgeWStacking }}
          </v-col>
          <v-col cols="12" class="yearsold textcolorblue py-0">
            {{ $t('L_years_old') }}
          </v-col>
          <v-col cols="12" class="interestpaid textcolorblue py-0">
            {{ $t('L_interest_paid') }}
          </v-col>
          <v-col cols="12" class="interestpaidamount textcolorblue py-0">
            {{ interestPaidWStacking }}
          </v-col>
        </v-row>
      </v-col>
      <!-- Without Debt Stacking -->
      <v-col :cols="$vuetify.display.xs ? '12' : '6'">
        <v-row>
          <v-col cols="12" class="debtstacking blacktext">
            {{ $t('L_without_debt_stacking') }}
            <v-tooltip
              max-width="300"
              html="true"
              open-on-click
              location="bottom"
              close-delay="2000"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  color="primary"
                  size="16"
                  v-bind="props"
                  class="moveiconup"
                  :icon="mdiHelpCircle"
                />
              </template>
              <span class="moveTextBelowIcon">
                <p v-html="$t('L_without_debt_stacking_this_illustration_assumes_that')" />
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" class="debtfreedomage blacktext">
            {{ $t('L_debt_freedom_age') }}
          </v-col>
          <v-col cols="12" class="age blacktext py-0">
            {{ debtFreeAgeWOStacking }}
          </v-col>
          <v-col cols="12" class="yearsold blacktext py-0">
            {{ $t('L_years_old') }}
          </v-col>
          <v-col cols="12" class="interestpaid blacktext py-0">
            {{ $t('L_interest_paid') }}
          </v-col>
          <v-col cols="12" class="interestpaidamount blacktext py-0">
            {{ interestPaidWOStacking }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- 3-column marketing  -->
    <v-row class="blueBackground">
      <v-col
        :cols="$vuetify.display.xs ? 12 : 4"
        :class="
          $vuetify.display.xs
            ? 'blueBackgroundMob blueBackgroundPaddingMob marginAuto'
            : 'blueBackground blueBackgroundPadding marginAuto'
        "
      >
        <div v-html="$t('L_get_out_of_debt', { year: yearsSooner, month: monthsSooner })" />
      </v-col>
      <v-col
        :cols="$vuetify.display.xs ? 12 : 4"
        :class="
          $vuetify.display.xs
            ? 'blueBackgroundMob marginAuto'
            : 'blueBackground centerDivUsingMargin marginAuto'
        "
      >
        <div
          :class="
            $vuetify.display.xs
              ? 'whitetopbottomborder blueBackgroundPaddingMob'
              : 'whiteleftrightborder blueBackgroundPadding'
          "
          v-html="totalDebtPaymentBlueBar"
        />
      </v-col>
      <v-col
        :cols="$vuetify.display.xs ? 12 : 4"
        :class="
          $vuetify.display.xs
            ? 'blueBackgroundMob blueBackgroundPaddingMob marginAuto'
            : 'blueBackground blueBackgroundPadding marginAuto'
        "
      >
        <span
          v-html="
            $t('L_avoid_paying_in_interest_charges', {
              interest: $n(interestSaved, 'currency', 'en-US'),
            })
          "
        />
      </v-col>
    </v-row>
    <!-- Still have questions about how debt stacking works? -->
    <v-row class="graybar text-center" justify="center">
      <v-col
        cols="12"
        align-self="center"
        class="textcolorblue text-caption font-weight-medium"
        :class="$vuetify.display.xs ? 'lineheightSmall pa-2' : 'lineheightBig'"
      >
        <span class="text-caption">{{ $t('L_still_have_questions_about_how_debt') }}</span>
        <OnexButton @click="showDebtVideo" variant="text" :prepend-icon="mdiYoutube">
          <span @click="showDebtVideo" class="font-weight-bold text-caption"
            >{{ $t('L_see_debt_stacking_in_action') }}
          </span>
        </OnexButton>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import { mdiHelpCircle, mdiYoutube } from '@mdi/js';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'DebtInfo',
  components: {
    OnexButton,
  },
  data: () => ({
    mdiHelpCircle,
    mdiYoutube,
  }),
  computed: {
    ...mapState(useDebtSolutionsStore, {
      planWOStacking: 'planWOStacking',
      planWStacking: 'planWStacking',
    }),
    WOStackingMonth() {
      try {
        return (
          12 * this.planWOStacking?.planTotals?.debtPayoffYears +
          this.planWOStacking?.planTotals?.debtPayoffMonths
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    WStackingMonth() {
      try {
        return (
          12 * this.planWStacking?.planTotals?.debtPayoffYears +
          this.planWStacking?.planTotals?.debtPayoffMonths
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    yearsSooner() {
      try {
        return Math.floor((this.WOStackingMonth - this.WStackingMonth) / 12);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    monthsSooner() {
      try {
        return (this.WOStackingMonth - this.WStackingMonth) % 12;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    interestSaved() {
      try {
        return (
          this.planWOStacking?.planTotals?.projectedInterestPaid -
          this.planWStacking?.planTotals?.projectedInterestPaid
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    totalCurrentDebt() {
      try {
        const balance = this.planWOStacking?.planTotals?.balance;

        if (isNaN(balance)) {
          return '';
        }
        return this.$n(balance, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    totalDebtPayment() {
      try {
        const totalDebt = this.planWOStacking?.planTotals?.totalDebtPmt;

        if (isNaN(totalDebt)) {
          return '';
        }
        return this.$n(totalDebt, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    primaryDatePayOffAgeWStacking() {
      try {
        return this.planWStacking?.planTotals?.primaryDebtPayoffAge;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    interestPaidWStacking() {
      try {
        return this.$n(this.planWStacking?.planTotals?.projectedInterestPaid, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    interestPaidWOStacking() {
      try {
        return this.$n(this.planWOStacking?.planTotals?.projectedInterestPaid, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    debtFreeAgeWOStacking() {
      try {
        return this.planWOStacking?.planTotals?.primaryDebtPayoffAge;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    totalDebtPaymentBlueBar() {
      try {
        const totalDebt = this.planWOStacking?.planTotals?.totalDebtPmt;

        if (isNaN(totalDebt)) {
          return '';
        }
        return this.$t('L_the_same_monthly_payment', {
          payment: this.$n(totalDebt, 'currency', 'en-US'),
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
  },
  methods: {
    updateYourDebt() {
      this.$emit('changeTab', 0);
    },
    showDebtVideo() {
      this.$emit('show-debt-video');
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style scoped lang="scss">
.graybar {
  background-color: #eeeeee;
}
.currentdebtinfo {
  font-size: 24px;
  color: #333333;
}
.currentdebtinfoMob {
  font-size: 24px;
  color: #333333;
}
.titleforpill {
  font-size: 14px;
  font-weight: 600;
}
.titleforpillMob {
  font-size: 14px;
  font-weight: 600;
  margin-top: -10px;
}
.whitepill {
  background-color: white;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 600;
  height: 35px;
  line-height: 35px;
  width: 135px;
  margin: auto;
  display: inline-block;
}
.whitepillMob {
  background-color: white;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 600;
  height: 35px;
  line-height: 35px;
  width: 150px;
  margin: auto;
}
.updateyourdebtbutton {
  border: 1px solid #063562;
  font-size: 12px;
  color: #063562;
  padding: 0px 10px 10px 10px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #ffffff;
}
.updateyourdebtbuttonMob {
  border: 1px solid #063562;
  font-size: 12px;
  color: #063562;
  padding: 0px 10px 0 10px;
  background-color: #ffffff;
  height: auto;
  line-height: 45px;
  margin-left: 20px;
  margin-right: 20px;
}
.updateyourdebtbutton:hover {
  background-color: #eeeeee;
  cursor: pointer;
}
.debtstacking {
  font-size: 20px;
  margin-top: 20px;
}
.debtfreedomage {
  font-size: 16px;
  font-weight: 600;
}
.age {
  font-size: 42px;
  line-height: 42px;
}
.yearsold {
  font-size: 12px;
}
.interestpaid {
  font-size: 12px;
  font-weight: 600;
  margin-top: 15px;
}
.interestpaidamount {
  font-size: 18px;
  margin-bottom: 40px;
}
.blacktext {
  color: #333333;
}
.lineargradient {
  background-image: linear-gradient(to right, #000000, rgba(254, 254, 254, 0));
  height: 100%;
  width: 16px;
  opacity: 0.26;
}
.blackborder {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.blueBackground {
  background-color: #063562;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
}
.blueBackgroundMob {
  background-color: #063562;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
}
.blueBackgroundPadding {
  padding: 2px 40px 2px 40px;
}
.blueBackgroundPaddingMob {
  padding: 12px 10px 12px 10px;
}
.textcolorblue {
  color: #063562;
}
.whiteleftrightborder {
  border-left: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
}
.whitetopbottomborder {
  border-top: 1px solid #ffffff;
  border-bottom: 1px solid #ffffff;
  margin-left: 20px;
  margin-right: 20px;
}
.centerDivUsingMargin {
  margin: auto;
}
.lineheightBig {
  line-height: 40px;
}
.lineheightSmall {
  line-height: 30px;
}
.moveiconup {
  position: absolute;
  margin-top: -3px;
}
.positionIcon {
  top: 5px;
  position: relative;
}
.updateYourDebtLabelMobile {
  line-height: 15px;
  width: 180px;
  max-width: 180px;
  margin: auto;
}
.cursorPointer {
  cursor: pointer;
}
.debtStackingTopBottomSeparator {
  position: relative;
  background: linear-gradient(#ffffff, #607697);
  height: 5px;
  width: 100%;
  margin-top: -258px;
}
.debtStackingLeftRightSeparator {
  position: relative;
  left: 50%;
  background: linear-gradient(90deg, black, transparent);
  height: 254px;
  width: 5px;
  text-align: center;
  margin-top: -254px;
}
.marginAuto {
  margin: auto;
}
</style>
